import React from 'react';
import { useTranslation } from 'react-i18next';

import { MetadataViewModel } from './metadata-models';
import { GenericDeleteModal } from 'src/js/component/generic-delete-modal';

interface Props {
  itemsToDelete: MetadataViewModel[];
  onApply: (items: MetadataViewModel[]) => Promise<any>;
  onCancel: VoidFunction;
}

export const MetadataDeleteConfirmModal: React.FunctionComponent<Props> = ({ itemsToDelete, onApply, onCancel }) => {
  const { t } = useTranslation();

  const handleDelete = () => {
    return onApply(itemsToDelete);
  };

  return (
    <GenericDeleteModal
      title={t('metadata.settings.modal.delete.title', { count: itemsToDelete.length })}
      body={`${t('metadata.settings.modal.delete.bodyText')} ${t('general.cannotUndo')}`}
      itemsToDelete={itemsToDelete}
      onCancel={onCancel}
      onDelete={handleDelete}
      onSuccess={onCancel}
    />
  );
};
